/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    SharedserviceMelcoModelsReferences,
    SharedserviceMelcoModelsReferencesFromJSON,
    SharedserviceMelcoModelsReferencesFromJSONTyped,
    SharedserviceMelcoModelsReferencesToJSON,
} from './';

/**
 * 
 * @export
 * @interface SharedserviceMelcoModelsAlphabetCollectionReferences
 */
export interface SharedserviceMelcoModelsAlphabetCollectionReferences {
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsReferences>}
     * @memberof SharedserviceMelcoModelsAlphabetCollectionReferences
     */
    mapping_list?: Array<SharedserviceMelcoModelsReferences> | null;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsReferences>}
     * @memberof SharedserviceMelcoModelsAlphabetCollectionReferences
     */
    global_mapping_list?: Array<SharedserviceMelcoModelsReferences> | null;
    /**
     * 
     * @type {Array<SharedserviceMelcoModelsReferences>}
     * @memberof SharedserviceMelcoModelsAlphabetCollectionReferences
     */
    format_list?: Array<SharedserviceMelcoModelsReferences> | null;
}

export function SharedserviceMelcoModelsAlphabetCollectionReferencesFromJSON(json: any): SharedserviceMelcoModelsAlphabetCollectionReferences {
    return SharedserviceMelcoModelsAlphabetCollectionReferencesFromJSONTyped(json, false);
}

export function SharedserviceMelcoModelsAlphabetCollectionReferencesFromJSONTyped(json: any, ignoreDiscriminator: boolean): SharedserviceMelcoModelsAlphabetCollectionReferences {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'mapping_list': !exists(json, 'mapping_list') ? undefined : (json['mapping_list'] === null ? null : (json['mapping_list'] as Array<any>).map(SharedserviceMelcoModelsReferencesFromJSON)),
        'global_mapping_list': !exists(json, 'global_mapping_list') ? undefined : (json['global_mapping_list'] === null ? null : (json['global_mapping_list'] as Array<any>).map(SharedserviceMelcoModelsReferencesFromJSON)),
        'format_list': !exists(json, 'format_list') ? undefined : (json['format_list'] === null ? null : (json['format_list'] as Array<any>).map(SharedserviceMelcoModelsReferencesFromJSON)),
    };
}

export function SharedserviceMelcoModelsAlphabetCollectionReferencesToJSON(value?: SharedserviceMelcoModelsAlphabetCollectionReferences | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'mapping_list': value.mapping_list === undefined ? undefined : (value.mapping_list === null ? null : (value.mapping_list as Array<any>).map(SharedserviceMelcoModelsReferencesToJSON)),
        'global_mapping_list': value.global_mapping_list === undefined ? undefined : (value.global_mapping_list === null ? null : (value.global_mapping_list as Array<any>).map(SharedserviceMelcoModelsReferencesToJSON)),
        'format_list': value.format_list === undefined ? undefined : (value.format_list === null ? null : (value.format_list as Array<any>).map(SharedserviceMelcoModelsReferencesToJSON)),
    };
}


